/* ============================================================
   PURE BIRKDALE — PDP behaviour (ported from pdp.jsx)
   Shade picker over real variants, selling-plan Subscribe & Save,
   consultation gate, gallery, qty, recommendations.
   ============================================================ */
(function () {
  'use strict';
  var root = document.querySelector('[data-pdp]');
  if (!root) return;

  var productJson = document.querySelector('[data-product-json]');
  var product = productJson ? JSON.parse(productJson.textContent) : null;
  var shadesJson = document.querySelector('[data-shades-json]');
  var shades = shadesJson ? JSON.parse(shadesJson.textContent) : null;
  if (!product) return;

  var shadeOptionIndex = root.dataset.shadeOptionIndex === '' ? null : Number(root.dataset.shadeOptionIndex);
  var needsConsult = root.dataset.consult === 'true';
  var consultOk = false;
  try { consultOk = localStorage.getItem('pb_consult_approved') === '1'; } catch (e) {}

  var state = {
    qty: 1,
    options: product.options.map(function () { return null; }),
    subscribe: false,
    sellingPlan: null
  };
  // preselect single-value options
  product.options.forEach(function (opt, i) {
    var values = {};
    product.variants.forEach(function (v) { values[v.options[i]] = true; });
    var keys = Object.keys(values);
    if (keys.length === 1) state.options[i] = keys[0];
  });

  function money(cents) {
    var format = (window.PBTheme && window.PBTheme.moneyFormat) || '£{{amount}}';
    var amount = (cents / 100).toFixed(2).replace(/\.00$/, '');
    return format.replace(/\{\{\s*amount[^}]*\}\}/, amount).replace(/<[^>]+>/g, '');
  }

  function currentVariant() {
    return product.variants.find(function (v) {
      return v.options.every(function (val, i) { return state.options[i] === null || state.options[i] === val; });
    }) || null;
  }

  function allChosen() {
    return state.options.every(function (o) { return o !== null; });
  }

  /* ---------- shade swatches ---------- */
  var shadeGrid = root.querySelector('[data-shade-grid]');
  if (shadeGrid && shades) {
    Array.prototype.forEach.call(shadeGrid.querySelectorAll('.shade-sw'), function (sw) {
      var code = sw.dataset.shadeCode;
      var shade = shades.find(function (s) { return s.code === code || code.indexOf(s.code) === 0; });
      if (shade) sw.style.backgroundColor = shade.hex; /* not the shorthand — it would nuke background-size for the photo view */
    });
  }
  var shadeView = 'swatch';
  Array.prototype.forEach.call(root.querySelectorAll('[data-shade-view]'), function (btn) {
    btn.addEventListener('click', function () {
      shadeView = btn.dataset.shadeView;
      Array.prototype.forEach.call(root.querySelectorAll('[data-shade-view]'), function (b) { b.classList.toggle('on', b === btn); });
      if (shadeGrid) {
        shadeGrid.classList.toggle('bottles', shadeView === 'photo');
        applyShadeView();
      }
    });
  });
  function applyShadeView() {
    var photo = shadeView === 'photo';
    Array.prototype.forEach.call(root.querySelectorAll('.shade-sw'), function (sw) {
      var src = photo ? thumbSrcForCode(sw.dataset.shadeCode) : null;
      if (src) {
        sw.style.backgroundImage = 'url("' + src + '")';
        sw.classList.add('has-img');
      } else {
        sw.style.backgroundImage = '';
        sw.classList.remove('has-img');
        var shade = shades && shades.find(function (s) { return sw.dataset.shadeCode.indexOf(s.code) === 0; });
        if (shade) sw.style.backgroundColor = shade.hex;
      }
    });
  }
  if (shadeGrid) {
    shadeGrid.addEventListener('click', function (e) {
      var sw = e.target.closest('.shade-sw');
      if (!sw) return;
      selectShade(sw.dataset.shadeCode);
    });
  }
  function selectShade(code) {
    if (shadeOptionIndex === null) return;
    state.options[shadeOptionIndex] = code;
    Array.prototype.forEach.call(root.querySelectorAll('.shade-sw'), function (s) {
      s.classList.toggle('on', s.dataset.shadeCode === code);
    });
    var nameEl = root.querySelector('[data-shade-name]');
    var shade = shades && shades.find(function (s) { return code.indexOf(s.code) === 0; });
    if (nameEl) nameEl.textContent = shade && shade.name && shade.name !== code ? code + ' · ' + shade.name : code;
    var hint = root.querySelector('[data-shade-hint]');
    if (hint) hint.hidden = true;
    showMediaForShade(code);
    update();
  }
  window.PBSelectShade = selectShade; /* used by the shade finder result */

  /* undertone quick-pick */
  var utRow = root.querySelector('[data-undertone-row]');
  if (utRow && shades) {
    [['cool', 'Cool'], ['neutral', 'Neutral'], ['warm', 'Warm']].forEach(function (pair) {
      var match = shades.find(function (s) { return s.undertone === pair[0]; });
      if (!match) return;
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'ur-chip';
      b.innerHTML = '<span class="ur-dot" style="background:' + match.hex + '"></span>' + pair[1] + ' → ' + match.name;
      b.addEventListener('click', function () { selectShade(match.code); });
      utRow.appendChild(b);
    });
  }

  /* ---------- non-shade option selects ---------- */
  Array.prototype.forEach.call(root.querySelectorAll('[data-option-select]'), function (sel) {
    sel.addEventListener('change', function () {
      state.options[Number(sel.dataset.optionIndex)] = sel.value;
      update();
    });
  });

  /* ---------- gallery ---------- */
  var mediaItems = Array.prototype.slice.call(root.querySelectorAll('.pdp-media-item'));
  var thumbs = Array.prototype.slice.call(root.querySelectorAll('.pdp-thumb'));
  function showMedia(id) {
    mediaItems.forEach(function (m) { m.hidden = m.dataset.mediaId !== String(id); });
    thumbs.forEach(function (t) { t.classList.toggle('on', t.dataset.mediaId === String(id)); });
  }
  thumbs.forEach(function (t) { t.addEventListener('click', function () { showMedia(t.dataset.mediaId); }); });
  function altHasCode(alt, code) {
    /* exact token match — "20N" must not match "320N", "60W" must not match "160W" */
    return (alt || '').split(/\s+/).indexOf(code) !== -1;
  }
  function showMediaForShade(code) {
    /* per-shade gallery: media whose alt carries the shade code (README: shade photos wire up by name) */
    var matches = mediaItems.filter(function (m) { return altHasCode(m.dataset.alt, code); });
    var visible = 0;
    thumbs.forEach(function (t) {
      var hit = altHasCode(t.dataset.alt, code);
      var hide = matches.length && !hit;
      t.style.display = hide ? 'none' : '';
      if (!hide) visible++;
    });
    /* a lone thumbnail just duplicates the main image — and with the strip
       gone the gallery grid must collapse to one column, or the main image
       lands in the 72px thumbnail track (blank gallery on iPad/desktop) */
    var strip = root.querySelector('[data-pdp-thumbs]');
    if (strip) strip.style.display = visible < 2 ? 'none' : '';
    var gal = root.querySelector('.pdp-gallery');
    if (gal) gal.style.gridTemplateColumns = visible < 2 ? '1fr' : '';
    if (matches.length) showMedia(matches[0].dataset.mediaId);
  }
  function thumbSrcForCode(code) {
    /* pick this shade's photo thumb — prefer suffixed alts ("10C compact") over the bare swatch shot */
    var pick = null;
    thumbs.forEach(function (t) {
      var alt = t.dataset.alt || '';
      if (!altHasCode(alt, code)) return;
      if (!pick || alt.length > (pick.dataset.alt || '').length) pick = t;
    });
    var img = pick && pick.querySelector('img');
    return img ? (img.currentSrc || img.src) : null;
  }
  /* honour ?variant= deep links — preselect that variant's options/shade */
  var urlVariantId = new URLSearchParams(location.search).get('variant');
  if (urlVariantId) {
    var urlVariant = product.variants.find(function (v) { return String(v.id) === urlVariantId; });
    if (urlVariant) {
      urlVariant.options.forEach(function (val, i) { state.options[i] = val; });
      if (shadeOptionIndex !== null) selectShade(urlVariant.options[shadeOptionIndex]);
    }
  }
  /* before a shade is chosen, show only the first shade's photos —
     otherwise every shade's image stacks into a huge gallery on mobile */
  if (shades && shadeOptionIndex !== null && state.options[shadeOptionIndex] === null && product.variants.length) {
    showMediaForShade(product.variants[0].options[shadeOptionIndex]);
  }
  /* hide the photo-view toggle when no media actually carries shade codes */
  if (shades && !shades.some(function (s) { return thumbSrcForCode(s.code); })) {
    var tog = root.querySelector('.shade-toggle');
    if (tog) tog.hidden = true;
  }

  /* ---------- subscribe & save ---------- */
  var subBox = root.querySelector('[data-subscribe-box]');
  if (subBox) {
    var freqRow = subBox.querySelector('[data-sub-freq]');
    var firstPlan = subBox.querySelector('[data-selling-plan]');
    Array.prototype.forEach.call(subBox.querySelectorAll('[data-sub-opt]'), function (opt) {
      opt.addEventListener('click', function () {
        state.subscribe = opt.dataset.subOpt === 'subscribe';
        state.sellingPlan = state.subscribe && firstPlan ? firstPlan.dataset.sellingPlan : null;
        Array.prototype.forEach.call(subBox.querySelectorAll('[data-sub-opt]'), function (o) { o.classList.toggle('on', o === opt); });
        if (freqRow) freqRow.hidden = !state.subscribe;
        update();
      });
    });
    Array.prototype.forEach.call(subBox.querySelectorAll('[data-selling-plan]'), function (btn) {
      btn.addEventListener('click', function () {
        state.sellingPlan = btn.dataset.sellingPlan;
        Array.prototype.forEach.call(subBox.querySelectorAll('[data-selling-plan]'), function (b) { b.classList.toggle('on', b === btn); });
      });
    });
  }

  /* ---------- qty ---------- */
  var qtyVal = root.querySelector('[data-qty-value]');
  root.querySelector('[data-qty-minus]').addEventListener('click', function () { state.qty = Math.max(1, state.qty - 1); update(); });
  root.querySelector('[data-qty-plus]').addEventListener('click', function () { state.qty += 1; update(); });

  /* ---------- price + ATC state ---------- */
  var priceEl = root.querySelector('[data-pdp-price]');
  var wasEl = root.querySelector('[data-pdp-was]');
  var saveEl = root.querySelector('[data-pdp-save]');
  var atc = root.querySelector('[data-pdp-atc]');
  function subUnit(variant) { return Math.round(variant.price * 0.9); }

  function update() {
    if (qtyVal) qtyVal.textContent = state.qty;
    var variant = allChosen() ? currentVariant() : null;
    var ref = variant || product.variants[0];
    var unit = state.subscribe ? subUnit(ref) : ref.price;
    if (priceEl) priceEl.textContent = money(unit);
    if (wasEl) { wasEl.hidden = !state.subscribe; wasEl.textContent = money(ref.price); }
    if (saveEl) saveEl.hidden = !state.subscribe;
    var onetimePrice = root.querySelector('[data-onetime-price]');
    if (onetimePrice) onetimePrice.textContent = money(ref.price);

    if (needsConsult && !consultOk) {
      atc.textContent = 'Consultation required';
      atc.disabled = true;
    } else if (!allChosen()) {
      var missing = product.options[state.options.indexOf(null)];
      atc.textContent = 'Select ' + missing.toLowerCase();
      atc.disabled = true;
    } else if (!variant || !variant.available) {
      atc.textContent = variant ? 'Sold out' : 'Unavailable';
      atc.disabled = true;
    } else {
      atc.textContent = 'Add to bag · ' + money(unit * state.qty);
      atc.disabled = false;
    }
    /* switch main image to the variant's featured image — but never fight the
       shade gallery filter (its featured media may be a hidden thumb) */
    var shadeActive = shadeOptionIndex !== null && state.options[shadeOptionIndex];
    if (variant && variant.featured_media && !shadeActive) showMedia(variant.featured_media.id);
  }

  /* event add-on (Biome Bootcamp) — optional time slot saved as a line item property */
  var eaSlot = '';
  var eaWrap = root.querySelector('[data-event-addon]');
  if (eaWrap) {
    Array.prototype.forEach.call(eaWrap.querySelectorAll('[data-ea-slot]'), function (b) {
      b.addEventListener('click', function () {
        eaSlot = b.dataset.eaSlot || '';
        Array.prototype.forEach.call(eaWrap.querySelectorAll('[data-ea-slot]'), function (x) {
          x.classList.toggle('on', x === b);
        });
      });
    });
  }

  root.querySelector('[data-pdp-form]').addEventListener('submit', function (e) {
    e.preventDefault();
    var variant = currentVariant();
    if (!variant || atc.disabled) return;
    atc.disabled = true;
    var props = eaSlot ? { 'Biome Bootcamp': eaSlot } : null;
    window.PBCart.add(variant.id, state.qty, state.subscribe ? state.sellingPlan : null, props)
      .catch(function (err) { alert((err && err.description) || 'Could not add to bag.'); })
      .finally(function () { atc.disabled = false; update(); });
  });

  /* ---------- consultation gate ---------- */
  var modal = document.querySelector('[data-consult-modal]');
  if (modal) {
    var stages = {
      form: modal.querySelector('[data-consult-stage="form"]'),
      approved: modal.querySelector('[data-consult-stage="approved"]'),
      refer: modal.querySelector('[data-consult-stage="refer"]')
    };
    function showStage(name) {
      Object.keys(stages).forEach(function (k) { if (stages[k]) stages[k].hidden = k !== name; });
      var title = modal.querySelector('[data-consult-title]');
      if (title) title.textContent = name === 'approved' ? "You're approved" : name === 'refer' ? "Let's book you in" : product.title;
    }
    Array.prototype.forEach.call(document.querySelectorAll('[data-consult-open]'), function (b) {
      b.addEventListener('click', function () { modal.hidden = false; showStage('form'); });
    });
    Array.prototype.forEach.call(modal.querySelectorAll('[data-consult-close], [data-consult-close-bg]'), function (b) {
      b.addEventListener('click', function () { modal.hidden = true; });
    });
    var back = modal.querySelector('[data-consult-back]');
    if (back) back.addEventListener('click', function () { showStage('form'); });

    /* segmented yes/no buttons */
    Array.prototype.forEach.call(modal.querySelectorAll('[data-seg]'), function (seg) {
      seg.addEventListener('click', function (e) {
        var btn = e.target.closest('button[data-val]');
        if (!btn) return;
        Array.prototype.forEach.call(seg.querySelectorAll('button'), function (b) { b.classList.toggle('on', b === btn); });
        var input = modal.querySelector('[data-seg-input="' + seg.dataset.seg + '"]');
        if (input) input.value = btn.dataset.val;
        if (seg.dataset.seg === 'used') {
          var detail = modal.querySelector('[data-used-detail]');
          if (detail) detail.hidden = btn.dataset.val !== 'yes';
        }
        validate();
      });
    });
    var agree = modal.querySelector('[data-consult-agree]');
    var submitBtn = modal.querySelector('[data-consult-submit]');
    var form = modal.querySelector('form');
    function validate() {
      var segsDone = ['pregnant', 'meds', 'used'].every(function (k) {
        var i = modal.querySelector('[data-seg-input="' + k + '"]');
        return i && i.value;
      });
      submitBtn.disabled = !(segsDone && agree.checked && form.checkValidity());
    }
    modal.addEventListener('input', validate);
    if (agree) agree.addEventListener('change', validate);

    form.addEventListener('submit', function (e) {
      var pregnant = modal.querySelector('[data-seg-input="pregnant"]').value;
      if (pregnant === 'yes') {
        /* purchase stays locked — route to an in-clinic consult, don't submit */
        e.preventDefault();
        showStage('refer');
        return;
      }
      /* normal answers → instant approval; the contact form still POSTs so the
         clinic gets the submission (page reloads after Shopify handles it). */
      try { localStorage.setItem('pb_consult_approved', '1'); } catch (err) {}
      try { sessionStorage.setItem('pb_consult_just_approved', '1'); } catch (err) {}
    });

    var cont = modal.querySelector('[data-consult-continue]');
    if (cont) cont.addEventListener('click', function () {
      modal.hidden = true;
      consultOk = true;
      var note = root.querySelector('[data-consult-note]');
      if (note) note.remove();
      update();
    });
    /* returning from the contact-form POST redirect */
    try {
      if (sessionStorage.getItem('pb_consult_just_approved') === '1') {
        sessionStorage.removeItem('pb_consult_just_approved');
        modal.hidden = false;
        showStage('approved');
      }
    } catch (err) {}
  }
  if (consultOk) {
    needsConsult = false;
    var note = root.querySelector('[data-consult-note]');
    if (note) note.remove();
  }

  /* ---------- recommendations ---------- */
  var recs = root.querySelector('[data-recommendations]');
  if (recs) {
    fetch(recs.dataset.url + '?product_id=' + recs.dataset.productId + '&limit=4&intent=related&section_id=product-recommendations')
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var tpl = document.createElement('div');
        tpl.innerHTML = html;
        var grid = tpl.querySelector('.pgrid');
        if (grid) recs.outerHTML = grid.outerHTML;
        else recs.closest('section').style.display = 'none';
      })
      .catch(function () { recs.closest('section').style.display = 'none'; });
  }

  update();
})();
